import { Alert, Button, Grid, Paper, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useSessionApiClient } from "../api/sessions";
import { useNavigate } from "react-router-dom";
import SessionsList from "../components/SessionsList";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    padding: theme.spacing(2),
    minHeight: "100vh",
    "& > *": {
      width: "100%",
    },
  },
  paper: {
    padding: theme.spacing(5),
    textAlign: "right",
  },
}));

const initialSessionInputValues = {
  inputParquetFile: "",
  imagesBasePath: "",
};

const isValidInputPath = (value) => {
  if (value.length === 0) return "This field is required";
  if (!value.startsWith("gs://") && !value.startsWith("https://"))
    return "Path must start with gs:// or https://";

  return "";
};

const NewSessionPage = () => {
  const classes = useStyles();
  const [sessionInputValues, setSessionInputValues] = useState(
    initialSessionInputValues
  );
  const [sessionInputErrors, setSessionInputErrors] = useState({
    inputParquetFile: "",
    imagesBasePath: "",
  });
  const [createNewSessionError, setCreateNewSessionError] = useState("");

  const navigate = useNavigate();
  const sessionApiClient = useSessionApiClient();

  const [inputParquetFileCount, setInputParquetFileCount] = useState(0);
  const [imagesBasePathCount, setImagesBasePathCount] = useState(0);

  const handleInputChange = (e) => {
    if (e.currentTarget.id === "input-parquet-file") {
      setInputParquetFileCount(inputParquetFileCount + 1);
    } else if (e.currentTarget.id === "images-base-path") {
      setImagesBasePathCount(imagesBasePathCount + 1);
    }
    const { name, value } = e.target;

    setSessionInputValues({
      ...sessionInputValues,
      [name]: value,
    });
  };

  const hasInputErrors = (sessionInputErrors) => {
    return (
      sessionInputErrors.inputParquetFile.length > 0 ||
      sessionInputErrors.imagesBasePath.length > 0
    );
  };

  useEffect(() => {
    setSessionInputErrors({
      inputParquetFile: isValidInputPath(sessionInputValues.inputParquetFile),
      imagesBasePath: isValidInputPath(sessionInputValues.imagesBasePath),
    });
  }, [sessionInputValues]);

  const createNewSession = async (e) => {
    e.preventDefault();
    try {
      const session = await sessionApiClient.createNewSession(
        sessionInputValues
      );
      setCreateNewSessionError("");
      navigate(`/sessions/${session.id}`, { replace: true });
    } catch (err) {
      setCreateNewSessionError(err);
    }
  };

  return (
    <Grid container spacing={0} direction="column" sx={{ padding: "1em" }}>
      <Grid item xs={6}>
        {createNewSessionError.length > 0 && (
          <Alert severity="error">{createNewSessionError}</Alert>
        )}
        <Paper elevation={3} className={classes.paper}>
          <TextField
            id="input-parquet-file"
            label="Input parquet file"
            inputProps={{ "aria-label": "input-parquet-file" }}
            variant="standard"
            onChange={handleInputChange}
            name="inputParquetFile"
            value={sessionInputValues.inputParquetFile}
            fullWidth
            error={
              inputParquetFileCount > 0 &&
              sessionInputErrors.inputParquetFile.length > 0
            }
            helperText={sessionInputErrors.inputParquetFile}
            placeholder="gs://path/to/input/images.parquet"
          />
          <br />
          <TextField
            id="images-base-path"
            label="Images base path"
            inputProps={{ "aria-label": "images-base-path" }}
            variant="standard"
            onChange={handleInputChange}
            name="imagesBasePath"
            value={sessionInputValues.imagesBasePath}
            fullWidth
            error={
              imagesBasePathCount > 0 &&
              sessionInputErrors.imagesBasePath.length > 0
            }
            helperText={sessionInputErrors.imagesBasePath}
            placeholder="gs://path/to/imgs/dir"
          />
          <Button
            variant="contained"
            size="large"
            onClick={createNewSession}
            disabled={hasInputErrors(sessionInputErrors)}
            sx={{ marginTop: "1em" }}
          >
            Start session
          </Button>
        </Paper>
        <Paper elevation={1}>
          <SessionsList />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default NewSessionPage;
